module.exports = __webpack_public_path__ + "img/u572.37671048.png";